const HomeActionTypes = {
    CHECK_STATUS: 'CHECK_STATUS',
    RELOAD_DATA: 'RELOAD_DATA',
    VEHICLE_NO: 'VEHICLE_NO',
    DIRECTION: 'DIRECTION',
}

export default HomeActionTypes;